// This is a placeholder for convenience.
// Eventually, react-media 2.0.0 will be released and will
// support Media taking multiple queries at once, and this
// component will no longer be needed.
import React from 'react';
import invariant from 'tiny-invariant';
import Media from 'react-media';

const MediaMinWidth = ({ breakpoints, _matchTuple, children }) => {
  invariant(breakpoints.length, 'At least one breakpoint should be present.');
  const head = breakpoints[0];
  const tail = breakpoints.slice(1);
  return (
    <Media query={`(min-width: ${head}px)`}>
      {headMatch => tail.length
        ? <MediaMinWidth breakpoints={tail} _matchTuple={(_matchTuple || []).concat([headMatch])}>
            {children}
          </MediaMinWidth>
        : children(...(_matchTuple || []).concat([headMatch]))}
    </Media>
  );
};

export default MediaMinWidth;
